import * as React from 'react';
import { connect } from 'react-redux';
import IBookmarkState from './interfaces/bookmarkState';
import ICategorizeModal from './interfaces/categorizeModal';
import { actionCreators } from './redux/actions';
import { BookmarkService } from '../../services/bookmarkService';
import { CategoriesService } from '../../services/categoriesService';
import { createPortal } from 'react-dom';
import { formatDate } from '../../modules/sidebarMostVisited';

class CategorizeModal extends React.Component<ICategorizeModal, null> {
    render() {
        const { bookmarks, display, selectedBookmarkId } = this.props;
        const bookmark = bookmarks.filter(b => b.id === selectedBookmarkId).pop();
        const buttonIsDisabled = !this.props.editedBookmarkName || !this.props.selectedCategoryId;

        return (
            createPortal(
                <React.Fragment>
                    {
                        display && bookmark ?
                            <div className="bookmarks__modal" onClick={(event) => event.stopPropagation()}>
                                <div className="bookmarks__modal-backdrop"></div>
                                <div className="bookmarks__modal-innercontainer">
                                    <button onClick={(event) => this.props.toggleCategorizeModal(event)} className="modal__close bookmarks__modal-close-btn">Stäng</button>
                                    <div className="modal__content">
                                        <h2 className="modal__title">Redigera favorit</h2>
                                        <p className="bookmarks__infobox">
                                            <a className="bookmarks__purple-link" href={bookmark.pageUrl}>{bookmark.pageTitle}</a>
                                            {bookmark.created ? (
                                                <span className="bookmarks__date">Favoritmarkerad: {formatDate(bookmark.created)}</span>
                                            ) : ""}
                                        </p>
                                        <div className="form-field">
                                            <input type="text" id="categoryName" className="form-field__textbox" autoComplete="off" autoFocus value={this.props.editedBookmarkName} onChange={(event) => this.props.setEditedBookmarkName(event)} />
                                            <label className="form-field__label" htmlFor="categoryName">Namn på favorit</label>
                                        </div>
                                        <div className="form-field">
                                            <label className="form-field__label" htmlFor="categoryName">Tilldela kategori</label>
                                            <div className="bookmarks__modal-select-group">
                                                <select id="selectedCategory" value={this.props.selectedCategoryId} onChange={(event) => { this.props.setSelectedCategory(event); }}>
                                                    <option value=''>Välj en kategori...</option>
                                                    {
                                                        this.props.categories && this.props.categories.length > 0 ?
                                                            this.props.categories.map((category, index) => {
                                                                return (
                                                                    category.categoryName && <option key={index} value={category.categoryId}>{category.categoryName}</option>
                                                                )
                                                            })
                                                            : null
                                                    }
                                                </select>
                                                <div>
                                                    <button className="genericBtn primary ghost" onClick={(e)=>this.props.toggleCreateModal && this.props.toggleCreateModal(e)} tabIndex={0}
                                                        onKeyUp={(e)=>{e.key==="Enter" && this.props.toggleCreateModal && this.props.toggleCreateModal(e)}}>+ Skapa ny kategori</button>
                                                        
                                                </div>
                                            </div>
                                        </div>
                                        <div className="button-group  modal__button-group">
                                            <button className="genericBtn alternate" onClick={(event) => this.props.deleteSelectedBookmark(event, this.props.selectedBookmarkId, this.props.categories, this.props.bookmarks)}>Ta bort favorit</button>
                                            <button className={`genericBtn primary ${buttonIsDisabled ? 'modal__button--disabled' : ''}`} onClick={(event) => this.props.updateBookmarkCategory(event, this.props.editedBookmarkName, this.props.selectedBookmarkId, this.props.selectedCategoryId, this.props.categories, this.props.bookmarks)}>Spara favorit</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            :
                            null
                    }
                </React.Fragment>,
                document.body)
        );
    }
}

const mapDispatchToProps = (dispatch, ownProps): ICategorizeModal => {
    const bookmarkService = new BookmarkService();
    const categoriesService = new CategoriesService();
    return {
        ...ownProps,
        toggleCreateModal: (event) => {
            event.preventDefault();
            dispatch(actionCreators.toggleCategorizeModal());
            dispatch(actionCreators.setDisplayCategorizeModalAfterCreateModal(true));
            dispatch(actionCreators.toggleCreateModal());
        },
        toggleCategorizeModal: (event) => {
            event.preventDefault();
            let bookmarkModal = document.getElementsByClassName("bookmarks__modal");
            dispatch(actionCreators.toggleCategorizeModal());
            if ($(bookmarkModal).length) {
                $("#favouritesList").attr("tabindex", "-1");
                $("#favouritesList").focus();
            }
        },
        deleteSelectedBookmark: (event, bookmarkId) => {
            event.preventDefault();
            if (bookmarkId) {
                bookmarkService.deleteBookmarkById(bookmarkId, (response) => {
                    if (response === '') {
                        categoriesService.getCategories((categories) => {
                            if (categories) {
                                dispatch(actionCreators.populateCategories(categories));
                            }
                        }, (error) => {
                            console.error({ error })
                        });
                        dispatch(actionCreators.toggleCategorizeModal());
                    }
                }, (error) => {
                    dispatch(actionCreators.setToastBarType('warn'));
                    dispatch(actionCreators.setToastBarMessage('Kunde inte ta bort favorit'));
                    dispatch(actionCreators.toggleToastBar());
                    console.error({ error });
                })
            }
        },
        updateBookmarkCategory: (event, bookmarkName, bookmarkId, categoryId, categoriesDataset, bookmarksDataset) => {
            event.preventDefault();
            if (bookmarkId && bookmarkName && categoryId && categoriesDataset && bookmarksDataset) {
                const bookmark = bookmarksDataset.filter(b => b.id === bookmarkId).pop();
                bookmark.categoryId = categoryId;
                bookmark.title = bookmarkName;
                
                const bookMarkObj = {
                    Id: bookmarkId,
                    CategoryId: categoryId,
                    Created: bookmark.created ?? null,
                    PageId: bookmark.pageId ?? 0,
                    PageTitle: bookmarkName,
                    DocumentMetaType: "",
                    PageUrl: bookmark.pageUrl ?? "",
                    Title: bookmark.title ?? "",
                    UserId: bookmark.userId ?? "",
                }

                bookmarkService.editBookmark(bookMarkObj, (response) => {
                    categoriesService.getCategories((categories) => {
                        if (categories) {
                            dispatch(actionCreators.populateCategories(categories));
                        }
                    }, (error) => {
                        console.error({ error })
                    });
                    dispatch(actionCreators.toggleCategorizeModal());
                    dispatch(actionCreators.setSelectedCategoryId(''));
                }, (error) => {
                    dispatch(actionCreators.toggleCategorizeModal());
                    dispatch(actionCreators.setToastBarType('warn'));
                    dispatch(actionCreators.setToastBarMessage('Kunde inte uppdatera favorit'));
                    dispatch(actionCreators.toggleToastBar());
                    console.error({ error });
                })
            }
        },
        setSelectedCategory: (event?) => {
            if (event) {
                event.preventDefault();
            }
            dispatch(actionCreators.setSelectedCategoryId(event.target.value));
        },
        setEditedBookmarkName: (event) => {
            event.preventDefault();
            dispatch(actionCreators.setEditedBookmarkName(event.target.value));
        }
    };
}

const mapStateToProps = (state: IBookmarkState): ICategorizeModal => {
    return { display: state.displayCategorizeModal, categories: state.categories, bookmarks: state.bookmarks, selectedBookmarkId: state.selectedBookmarkId, selectedCategoryId: state.selectedCategoryId, editedBookmarkName: state.editedBookmarkName };
}

export default connect(mapStateToProps, mapDispatchToProps)(CategorizeModal);